export const selectRoleOptions = [
  {
    options: [
      { value: 'smo', label: 'Руководитель маркетинга/CMO' },
      { value: 'agency', label: 'Сотрудник агентства' },
      { value: 'brend', label: 'Сотрудник бренда' },
      { value: 'analytics', label: 'Аналитик рынка' },
      { value: 'journalist', label: 'Журналист' },
      { value: 'other', label: 'Другое' }
    ]
  }
]

export const PLACE_TO_RENDER = {
  FORM: 'form',
  MODAL: 'modal'
} as const

export const VARIANT_TO_RENDER = {
  EDTECH: 'edtech',
  MEDICINE: 'medicine',
  REALTY: 'realty',
  STATISTICS: 'statistics'
} as const

export const INDEX_REQUEST = {
  EDTECH: 'edTech',
  MEDICAL: 'medical',
  REALESTATE: 'realestate',
  DAAI: 'DAAI',
  SUBSCRIBE: 'subscribe'
} as const
